module.exports = __webpack_public_path__ + "static/media/0_2019_05_05.2e180ae2.jpg";